export const PDF_NAME = 'Luciole-cartedevoeux.pdf';
export const PDF_NAME_HR = 'Luciole-cartedevoeux-HR.pdf';

export const SKIP_ANIMATION_STORAGE_KEY = 'SKIP_ANIMATION';

export const MENU_DESKTOP_WIDTH = 300;
export const MENU_MOBILE_HEADER_HEIGHT = 85;
export const MENU_MOBILE_FOOTER_HEIGHT = 75;
export const NAVIGATION_HEIGHT = 52;
export const MOBILE_NAVIGATION_HEIGHT = 40;
export const PDF_PAGE_RATIO = 339 / 190;
export const MODE_SINGLE_PAGE = false;
export const TITLE_LOADER = 'LUCIOLE';
export const PRESENTATION_TEXT = 'Nous transformons vos idées en réalité en alliant écoute attentive et expertise créative. Chaque projet est conçu pour refléter fidèlement votre vision, avec des designs sur-mesure qui capturent l\'essence de votre message.';
export const DOWNLOAD_TEXT = 'Télécharger ce portfolio';
export const SHARE_TEXT = 'Partager ce portfolio';
export const SHARE_TEXT_FACEBOOK = 'Partager sur Facebook';
export const SHARE_TEXT_X = 'Partager sur X';
export const SHARE_TEXT_LINKEDIN = 'Partager sur LinkedIn';
export const SHARE_TEXT_COPYPASTE = 'Copier le lien dans le presse-papier';
export const SHARE_TEXT_COPYPASTE_SUCCESS = 'Lien copié dans le presse papier';

export const FOLLOW_TEXT = 'NOUS SUIVRE';

export const LINKS = {
  // 4: {
  //   title: 'Voir le rapport d\'activité digital Sogaris',
  //   url: 'https://ra2023.sogaris.fr/',
  // },
  // 7: {
  //   title: 'Voir le rapport d\'activité digital ABM',
  //   url: 'https://rapport-annuel.agence-biomedecine.fr/',
  // },
  // 15: {
  //   title: 'Voir le rapport d\'activité digital ERAFP',
  //   url: 'https://rafp-ra2021.fr/',
  // },
  // 24: {
  //   title: 'Voir le rapport d\'activité digital Unicancer',
  //   url: 'https://unicancer.fr/rapport-activite/2023/',
  // },
}

const SHARE_URL = encodeURIComponent(window.location.href);
const SHARE_DESCRIPTION = encodeURIComponent('Luciole');
const SHARE_TITLE = encodeURI('Luciole');
export const WEBSITE_URL = 'https://luciole.com/';
export const FACEBOOK_SHARE_PARAMS = `http://www.facebook.com/share.php?u=${SHARE_URL}`;
export const X_SHARE_PARAMS = `http://x.com/intent/tweet?text=${SHARE_DESCRIPTION}&url=${SHARE_URL}`;
export const LINKEDIN_SHARE_PARAMS = ` https://www.linkedin.com/shareArticle?mini=true&url=${SHARE_URL}&title=${SHARE_TITLE}&summary=${SHARE_DESCRIPTION}`;
export const LINKEDIN_URL = 'https://www.linkedin.com/company/agence-luciole';

const CONFIG = {
  PDF_NAME,
  SKIP_ANIMATION_STORAGE_KEY,
  MENU_DESKTOP_WIDTH,
  MENU_MOBILE_HEADER_HEIGHT,
  MENU_MOBILE_FOOTER_HEIGHT,
  PDF_PAGE_RATIO,
  NAVIGATION_HEIGHT,
  LINKS,
  MOBILE_NAVIGATION_HEIGHT,
  FACEBOOK_SHARE_PARAMS,
  X_SHARE_PARAMS,
  WEBSITE_URL,
};

export default CONFIG;
